/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Routes} from '@angular/router';



import {showcaseLocaleGuard} from './showcase/showcase-locale.guard';

/**
 * Роуты публичной витрины (домен === environment.showcaseUrl).
 * Корневой layout — ShowcaseLayoutComponent (своя шапка/контейнер по дизайн-системе),
 * без общего LayoutComponent кабинета.
 *
 * Используется в showcase-сборке (CSR static, см. angular.json `nextshowcase`
 * configuration). В cabinet-сборке этот файл не подтягивается —
 * COMPO_APP_INITIALIZER.ts (cabinet вариант) не импортирует showCaseRoutes.
 */
export const showCaseRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./showcase/layout/showcase-layout.component').then(m => m.ShowcaseLayoutComponent),
    data: {showcase: true},
    canActivate: [showcaseLocaleGuard],
    children: [
      {path: '', redirectTo: 'catalog', pathMatch: 'full'},
      {path: 'catalog', loadComponent: () => import('./showcase/catalog/showcase-catalog.component').then(m => m.ShowcaseCatalogComponent), data: {showcase: true}},
      {path: 'product/:id', loadComponent: () => import('./showcase/product/showcase-product-page.component').then(m => m.ShowcaseProductPageComponent), data: {showcase: true}},
      {path: 'favorites', loadComponent: () => import('./showcase/favorites/showcase-favorites.component').then(m => m.ShowcaseFavoritesComponent), data: {showcase: true}},
      {path: '404', loadComponent: () => import('./showcase/shared/not-found/not-found.component').then(c => c.NotFoundComponent)},
      {path: '**', redirectTo: '/404'},
    ],
  },
];
